import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';
import { promoOffers, promoDetailProducts } from '@/mocks/promos';
import PromoDetailHero from './components/PromoDetailHero';
import PromoConditions from './components/PromoConditions';
import PromoProductList from './components/PromoProductList';
import OtherPromos from './components/OtherPromos';

const PromoDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  const offer = promoOffers.find((o) => o.id === Number(id));
  const products = promoDetailProducts[Number(id)] ?? [];

  if (!offer) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: '#050508' }}>
        <Navbar />
        <div className="text-center px-6 mt-20">
          <i className="ri-price-tag-3-line text-6xl text-white/10 mb-6 block" />
          <h1 className="font-orbitron font-black text-3xl text-white mb-3">Акция не найдена</h1>
          <p className="font-mono text-sm text-white/40 mb-8">Возможно, акция завершилась или была удалена</p>
          <Link
            to="/promos"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-xl font-orbitron font-bold text-sm cursor-pointer"
            style={{ background: '#ff2d78', color: '#050508', boxShadow: '0 0 20px rgba(255,45,120,0.4)' }}
          >
            <i className="ri-arrow-left-line" />
            Все акции
          </Link>
        </div>
      </div>
    );
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Offer',
    name: offer.title,
    description: offer.description,
    url: `${SITE_URL}/promos/${offer.id}`,
    priceSpecification: {
      '@type': 'PriceSpecification',
      discount: offer.discount,
    },
    validThrough: offer.endsAt,
  };

  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title={`${offer.title} — Акция NeonPharma | ${offer.discount} скидка`}
        description={`${offer.description} Скидка ${offer.discount}. ${offer.code ? `Промокод: ${offer.code}.` : ''} Только до ${new Date(offer.endsAt).toLocaleDateString('ru-RU')}.`}
        keywords={`акция аптека, ${offer.subtitle}, скидка лекарства, NeonPharma`}
        canonical={`/promos/${offer.id}`}
        jsonLd={jsonLd}
      />
      <Navbar />

      <PromoDetailHero offer={offer} productCount={products.length} />
      <PromoConditions offer={offer} />

      {/* Divider */}
      <div
        className="mx-6 lg:mx-12 h-px max-w-7xl mx-auto"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)' }}
      />

      <PromoProductList offer={offer} products={products} />
      <OtherPromos currentId={offer.id} />

      <Footer />
    </div>
  );
};

export default PromoDetailPage;
